import { Api } from 'api';
import $volc from './volcengine';
import { resolveReportIds } from 'utils/reportIds';

class Track {
  constructor() {
    this.$volc = $volc;
  }
  async track(options, payload) {
    let method = options?.method || 'click';
    let event = options?.event || options || 'default_track';
    const { uuid, sessionId } = resolveReportIds();
    const reportPayload = payload || options?.payload || {}
    await Api.post.postBuryDot({
      event,
      ip: uuid,
      browser_uuid: uuid,
      session_uuid: sessionId,
      payload: reportPayload
    });
    this.$volc.sendEvent(event, {
      ...reportPayload,
      browser_uuid: uuid,
      session_uuid: sessionId,
    });
  }
  stayCount(options, payload) {
    let event = options?.event || options;
    const { uuid, sessionId } = resolveReportIds();
    let stay_time = 0;
    const counterInterval = setInterval(() => {
      stay_time += 1;
    }, 1000);
    const reportPayload = payload || options?.payload || {}
    const stop = () => {
      clearInterval(counterInterval);
      this.$volc.sendEvent(event, {
        ...reportPayload,
        stay_time,
        browser_uuid: uuid,
        session_uuid: sessionId,
        beacon: true
      });
    };
    window.addEventListener('beforeunload', () => {
      stop();
    });
    return stop;
  }
}
export default Track;
